// Hooks
// import { useProtectedContent } from "../../hooks/useProtectedContent";
// Components
// import { ComponentAuthorisation } from "../../components/ComponentAuthorisation";
// MUI
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import DashboardCard from "./DashboardCard";

export default function DashboardCardRow({ title, cards }) {
  const enabledCardsCount = cards.filter((obj) => obj.enabled === true).length;
  return (
    <Box sx={{ pb: 2 }}>
      <Typography component="div" variant="h6" sx={{ pb: 1 }}>
        {title}
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        // columns={{ xs: 1, sm: 2, lg: cards.length }}
        columns={{ xs: 1, sm: 2, lg: enabledCardsCount }}
        sx={{
          alignItems: "stretch",
        }}
      >
        {cards.map((card) => {
          if (card.enabled) {
            return (
              <Grid key={card.heading} size={1}>
                <DashboardCard
                  currency={card.currency}
                  heading={card.heading}
                  subheading={card.subheading}
                  icon={card.icon}
                  link={card.link}
                  iconColour={card.iconColour}
                  newTab={card.newTab}
                />
              </Grid>
            );
          }
        })}
      </Grid>
    </Box>
  );
}
